import axios from "axios";
import { APICore } from "./apiCore";

const api = new APICore();

function addBanner(
  params: {
    heading: string;
    heading_ar: string;
    non_animate_text: string;
    non_animate_text_ar: string;
    animate_text: string;
    animate_text_ar: string;
    para: string;
    para_ar: string;
  },
  image: File[] | null
) {
  const baseUrl = "/banner";
  return api.createWithMultiple(`${baseUrl}`, image, params);
}
function updateBanner(
  id: number,
  params: {
    heading: string;
    heading_ar: string;
    non_animate_text: string;
    non_animate_text_ar: string;
    animate_text: string;
    animate_text_ar: string;
    para: string;
    para_ar: string;
  },
  image: File[] | null
) {
  const baseUrl = `/banner/${id}`;
  return api.updateWithFiles(`${baseUrl}`, image, params);
}

function getBanner() {
  const baseUrl = "/banner";
  return api.get(`${baseUrl}`, {});
}

function deleteBanner(id: number) {
  const baseUrl = `/banner/${id}`;
  return api.delete(`${baseUrl}`);
}

function deleteBannerImageApi(ids: string[]) {
  const result = axios.delete(`/bannerImage`, { data: { ids } });
  return result;
}

export {
  addBanner,
  deleteBanner,
  getBanner,
  updateBanner,
  deleteBannerImageApi,
};
